// @ts-strict-ignore
import type { MergeDeepPartial } from "@lib/typeHelpers";

const isObject = (item: unknown) => {
  return item && typeof item === "object" && !Array.isArray(item);
};

/**
 * Taken from https://thewebdev.info/2021/03/06/how-to-deep-merge-javascript-objects/
 *
 * This is used to merge an object with a partial of itself. This is more robust than
 * lodash's implementation, and far smaller
 *
 * WARNING: This overwrites the target object
 */
export const mergeDeep = <T>(target: T, ...sources: Array<MergeDeepPartial<T>>): T => {
  if (!sources.length) {
    return target;
  }
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      const typedKey = key as keyof T & string;
      if (isObject(source[typedKey])) {
        if (!target[typedKey]) {
          Object.assign(target, {
            [typedKey]: {},
          });
        }
        mergeDeep(target[typedKey], source[typedKey]);
      } else {
        Object.assign(target, {
          [typedKey]: source[typedKey],
        });
      }
    }
  }

  return mergeDeep(target, ...sources);
};
